<!-- eslint-disable max-len -->
<template>
  <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M26.368 27.6875C26.368 28.532 23.5182 29.2357 19.9998 29.2357C16.4814 29.2357 13.6316 28.5671 13.6316 27.6875C13.6316 27.0544 15.1444 26.5265 17.361 26.2803V25.6118H22.6385V26.2803C24.8198 26.5265 26.3679 27.0541 26.3679 27.6875H26.368ZM30.5549 11.5736V24.0636C30.5549 24.5211 30.203 24.8728 29.7457 24.8728H10.2542C9.7967 24.8728 9.44501 24.5209 9.44501 24.0636V11.5736C9.44501 11.1161 9.79694 10.7644 10.2542 10.7644H29.7105C30.2031 10.7644 30.555 11.1161 30.555 11.5736H30.5549ZM29.1827 12.1365H10.817V23.5359H29.2179V12.1365H29.1827Z"
      :fill="pathFill"
    />
  </svg>
</template>

<script>
export default {
  props: {
    pathFill: {
      type: String,
      default: '#FFFFFF',
    },
  },
};
</script>
